import React, { useState } from 'react';
import moment from 'moment';
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';


const FilterSortBy = (props) => { 
    const [filterClass, setClass] = useState('');
    const [specifier, setSpecifier] = useState('');
    const [filterModalOpen, setFilterModalOpen] = useState(false);

    const sortBy = (param) => {
        let artifactArr = props.artifactsDisplay

        if(param === 'name'){
            artifactArr = artifactArr.sort((a,b)=>a.file_name.localeCompare(b.file_name));
        }else{
            artifactArr = artifactArr.sort((a,b)=> moment(b.submitted) - moment(a.submitted))
        }

        props.setArtifacts([...artifactArr]);
    }

    const filterBy = () => {
        let artifactArr = props.artifacts
        if(filterClass === 'Task'){
            artifactArr = artifactArr.filter((art)=> art.task_id === +specifier)
        }else if(filterClass === 'Employee'){
            artifactArr = artifactArr.filter((art)=> art.employee_id === +specifier)
        }else if(filterClass === 'All'){
            artifactArr = props.artifacts.filter((art)=> !!art.show)
        }else{
            artifactArr = artifactArr.filter((art)=> art.taskType === specifier)
        }
        props.setArtifacts(artifactArr);
        setClass('');
        setSpecifier('');
    }

    const filterHandler = (e) => {
        let id = e.target.id;
        let val = e.target.value;

        if(id === 'filter1'){
            setClass(val);
            setSpecifier('');
        }else{
            setSpecifier(val);
        }
    }

    return (
        <div className='filter-sortby-container'>
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <Button variant="outlined" size="small" sx={{ height: '40px', mr: 1 }} onClick={() => setFilterModalOpen(true)}>
                        <i className="fas fa-filter" style={{ marginRight: 4 }}></i> FILTER
                    </Button>
                    <div className="dropdown">
                        <button style={{ outline: 'none', color: '#1976D2', border: '1px solid #1976D2', height: '40px' }} className="btn btn-sm dropdown-toggle bg-white" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span><i style={{ color: '#1976D2' }} className="fas fa-sort-amount-up"></i></span> SORT BY
                        </button>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
                            <button onClick={()=> sortBy('name')} className="dropdown-item" type="button">Name</button>
                            <button onClick={()=> sortBy('date')} className="dropdown-item" type="button">Date</button>
                        </div>
                    </div>
            </div>
            <Dialog open={filterModalOpen} onClose={() => setFilterModalOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    Filter By
                    <IconButton onClick={() => setFilterModalOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <TextField
                        select
                        fullWidth
                        label="Class"
                        id="filter1"
                        value={!filterClass?'':filterClass}
                        onChange={(e)=> filterHandler(e)}
                        SelectProps={{ native: true }}
                        sx={{ mb: 2, mt: 1 }}
                    >
                        <option value="">Select Class</option>
                        <option value="All">All</option>
                        <option value="Task">Task</option>
                        <option value="Task Type">Task Type</option>
                        <option value="Employee">Employee</option>
                    </TextField>
                    {filterClass !== '' && filterClass !== 'All' &&
                        <TextField
                            select
                            fullWidth
                            label="Specify"
                            id="filter2"
                            value={!specifier?'':specifier}
                            onChange={(e)=> filterHandler(e)}
                            SelectProps={{ native: true }}
                        >
                            <option value="">Select Specifier</option>
                            {filterClass === 'Task' && props.taskList}
                            {filterClass === 'Task Type' && props.taskTypeList}
                            {filterClass === 'Employee' && props.empList}
                        </TextField>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { filterBy(); setFilterModalOpen(false); }} variant="contained">Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default FilterSortBy;